var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSolar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    height: "800px",
    width: "800px",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 612.002 612.002",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M611.567,370.172c-15.485-104.763-30.977-209.528-46.472-314.286c-3.239-21.938-21.6-38.483-42.711-38.483H89.621 c-21.104,0-39.467,16.539-42.715,38.477l-8.119,54.91c-12.779,86.46-25.56,172.921-38.351,259.374 c-1.698,11.465,1.61,23,9.075,31.651c7.806,9.046,19.478,14.233,32.024,14.233h86.416l81.462,84.521h-44.902 c-6.075,0-11.35,4.708-12.265,10.942l-10.309,69.7c-0.489,3.356,0.492,6.735,2.686,9.268c2.265,2.62,5.628,4.121,9.224,4.121 h304.305c3.605,0,6.971-1.506,9.238-4.133c2.19-2.54,3.165-5.919,2.668-9.279l-10.3-69.652 c-0.908-6.25-6.181-10.966-12.265-10.966h-44.903l81.46-84.521h86.415c12.543,0,24.216-5.187,32.022-14.232 C609.953,393.166,613.263,381.633,611.567,370.172z M308.865,500.569h-5.722l-81.46-84.521h168.639L308.865,500.569z  M52.305,365.435c12.192-82.413,24.374-164.828,36.556-247.243l7.414-50.175h419.452c14.66,99.139,29.318,198.279,43.974,297.418 H52.305z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "356.566,96.844 252.065,96.844 248.42,201.915 360.211,201.915  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.532,229.269l3.643,105.065h123.039c-5.178-35.023-10.36-70.042-15.534-105.065L388.532,229.269L388.532,229.269z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "247.472,229.269 243.831,334.335 364.806,334.335 361.159,229.269  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.101,96.844h-96.167l3.647,105.071h108.053C490.459,166.888,485.279,131.867,480.101,96.844z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.984,154.651c-2.324,15.756-4.655,31.51-6.98,47.264h108.049l3.645-105.071h-96.162L119.984,154.651z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.418,334.335h123.039l3.648-105.065H108.952C103.778,264.292,98.6,299.312,93.418,334.335z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolar);
export default __webpack_public_path__ + "static/media/solar.1d657257d4e831b7730882691543c7b6.svg";
export { ForwardRef as ReactComponent };